import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";

export const AdminRoute = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const openEdit = (item) => setEditItem(item);
  const closeEdit = () => setEditItem(null);

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getRoute();
      console.log(response);
      if (response?.success) {
        setData(response?.routes || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const delteRoute = async (id) => {
    if (!window.confirm("Are you sure you want to delete this route?")) return;
    try {
      const response = await api.deleteRoute(id);
      console.log(response);
      if (response?.success) {
        notify.success("Vehicle deleted successfully!");
        getData();
      }
    } catch (error) {
      console.log(error);

      notify.error("Something went wrong!");
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Route</h3>
            <Table data={data} delteRoute={delteRoute} openEdit={openEdit} />
          </div>
        </div>
        <div className="AddEmpBtn" onClick={handleShow}>
          <i className="fa-solid fa-plus"></i>
        </div>
      </div>
      <CreateModal show={show} handleClose={handleClose} getRoute={getData} />
      {editItem && <EditRouteModal item={editItem} handleClose={closeEdit} getRoute={getData} />}
      {/* /.container-fluid */}
    </>
  );
};

const NumberPlate = ({ number }) => (
  <div style={{ display: "inline-block", background: "#fff", border: "2.5px solid #222", borderRadius: 6, overflow: "hidden", minWidth: 120, boxShadow: "0 1px 4px rgba(0,0,0,0.15)" }}>
    <div style={{ background: "repeating-linear-gradient(90deg, #c0392b 0px, #c0392b 10px, #e74c3c 10px, #e74c3c 14px, #c0392b 14px, #c0392b 24px)", height: 8 }} />
    <div style={{ padding: "4px 10px 2px", textAlign: "center", fontWeight: 900, fontSize: 15, letterSpacing: 3, color: "#111", fontFamily: "'Courier New', monospace", textTransform: "uppercase" }}>
      {number || "—"}
    </div>
    <div style={{ textAlign: "center", fontSize: 8, fontWeight: 700, letterSpacing: 4, color: "#444", paddingBottom: 4, textTransform: "uppercase" }}>
      SINDH
    </div>
  </div>
);

const Table = ({ data, delteRoute, openEdit }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Start Location</th>
                <th scope="col">End Location</th>
                <th scope="col">Stops</th>
                <th scope="col">Assigned Vehicle</th>
                <th scope="col">Assigned Driver</th>
                <th scope="col">Timings</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db" style={{ textTransform: "capitalize" }}>{item?.name}</div>
                  </td>
                  <td>
                    <span className="table-text-dark db" style={{ textTransform: "capitalize", display: "flex", alignItems: "center", gap: 6 }}>
                      <i className="fa-solid fa-location-dot" style={{ color: "#10b981", fontSize: 13 }} />
                      {item?.startLocation || "—"}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark db" style={{ textTransform: "capitalize", display: "flex", alignItems: "center", gap: 6 }}>
                      <i className="fa-solid fa-location-dot" style={{ color: "#ef4444", fontSize: 13 }} />
                      {item?.endLocation || "—"}
                    </span>
                  </td>
                  <td>
                    {item?.stops?.filter(s => s).length > 0 ? (
                      <ul style={{ margin: 0, paddingLeft: 16 }}>
                        {item.stops.filter(s => s).map((val, i) => (
                          <li key={i} style={{ fontSize: 13, textTransform: "capitalize", color: "#374151" }}>{val}</li>
                        ))}
                      </ul>
                    ) : "—"}
                  </td>
                  <td>
                    <NumberPlate number={item?.assignedVehicle?.numberPlate} />
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db" style={{ textTransform: "capitalize" }}>{item?.assignedDriver?.name || "—"}</span>
                  </td>
                  <td>
                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                      <span style={{ fontSize: 12, color: "#374151" }}>
                        <span style={{ fontWeight: 600, color: "#1d4ed8" }}>Dep: </span>{item?.timings?.departure || "—"}
                      </span>
                      <span style={{ fontSize: 12, color: "#374151" }}>
                        <span style={{ fontWeight: 600, color: "#15803d" }}>Arr: </span>{item?.timings?.arrival || "—"}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span style={{
                      display: "inline-block",
                      padding: "3px 10px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600,
                      textTransform: "capitalize",
                      background: item?.status === "active" ? "#d1fae5" : "#fee2e2",
                      color: item?.status === "active" ? "#065f46" : "#991b1b",
                    }}>
                      {item?.status || "—"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex gap-2 align-items-center">
                      <div className="edit p-2 cursor-pointer" onClick={() => openEdit(item)}>
                        <i className="fa-solid fa-pen-to-square"></i>
                      </div>
                      <div className="delete p-2 cursor-pointer" onClick={() => delteRoute(item?._id)}>
                        <i className="fa-solid fa-trash"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const CreateModal = ({ show, handleClose, getRoute }) => {
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);
  const [stops, setStops] = useState([""]);

  const handleStopChange = (value, index) => {
    const newStops = [...stops];
    newStops[index] = value;
    setStops(newStops);
  };

  const addStop = () => setStops([...stops, ""]);
  const removeStop = (index) => setStops(stops.filter((_, i) => i !== index));

  const handleSubmit = async () => {
    try {
      console.log(data);
      let payload = {
        name: data?.name,
        startLocation: data?.startLocation,
        endLocation: data?.endLocation,
        stops: stops,
        assignedVehicle: data?.assignedVehicle,
        assignedDriver: data?.assignedDriver,
        timings: {
          departure: data?.departure ? moment(data.departure, "HH:mm").format("hh:mm A") : "",
          arrival: data?.arrival ? moment(data.arrival, "HH:mm").format("hh:mm A") : "",
        },
      };
      console.log(payload);
      console.log(stops);

      const response = await api.addRoute(payload);
      console.log(response);
      if (response?.success) {
        await getRoute();
        notify.success("Route successfully added!");
        setData({});
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getVehicle();
      console.log(response);
      if (response?.success) {
        setVehicles(response?.vehicles || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const getDriverData = async () => {
    try {
      setLoader(true);
      const response = await api.getDrivers();
      console.log(response);
      if (response?.success) {
        setDrivers(response?.drivers || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
    getDriverData();
  }, []);

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Add Route</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Start Location</label>
              <input
                type="text"
                name="startLocation"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>End Location</label>
              <input
                type="text"
                name="endLocation"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label className="">Stops:</label>
              {stops.map((stop, index) => (
                <div key={index} className="d-dlex gap-2 mb-2">
                  <input
                    type="text"
                    placeholder={`Stop ${index + 1}`}
                    value={stop}
                    onChange={(e) => handleStopChange(e.target.value, index)}
                    className="form-control"
                  />
                  {stops.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeStop(index)}
                      className="bg-red-500 text-white px-2"
                    >
                      ❌
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                onClick={addStop}
                style={{ background: "#1b2580", color: "#fff", border: "none", borderRadius: 7, padding: "7px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}
              >
                <i className="fa-solid fa-plus" /> Add Stop
              </button>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Departure Time</label>
              <input
                type="time"
                name="departure"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Arrival Time</label>
              <input
                type="time"
                name="arrival"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>

          <div className="col-12">
            <div className="form-group">
              <label>Assigned Vehicle</label>
              <select
                name="assignedVehicle"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              >
                <option value="">Select</option>
                {vehicles.map((item, key) => (
                  <option value={item?._id} key={key}>
                    {item?.numberPlate}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Assigned Driver</label>
              <select
                name="assignedDriver"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              >
                <option value="">Select</option>
                {drivers.map((item, key) => (
                  <option value={item?._id} key={key}>
                    {item?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="mt-4 ">
          <button className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};

const EditRouteModal = ({ item, handleClose, getRoute }) => {
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [loader, setLoader] = useState(false);
  const [stops, setStops] = useState(item?.stops?.length ? item.stops : [""]);
  const [data, setData] = useState({
    name: item?.name || "",
    startLocation: item?.startLocation || "",
    endLocation: item?.endLocation || "",
    departure: item?.timings?.departure ? moment(item.timings.departure, "hh:mm A").format("HH:mm") : "",
    arrival: item?.timings?.arrival ? moment(item.timings.arrival, "hh:mm A").format("HH:mm") : "",
    assignedVehicle: item?.assignedVehicle?._id || "",
    assignedDriver: item?.assignedDriver?._id || "",
  });

  const onTextChange = (e) => setData({ ...data, [e.target.name]: e.target.value });
  const handleStopChange = (value, index) => { const s = [...stops]; s[index] = value; setStops(s); };
  const addStop = () => setStops([...stops, ""]);
  const removeStop = (index) => setStops(stops.filter((_, i) => i !== index));

  const handleSubmit = async () => {
    try {
      const payload = {
        name: data?.name,
        startLocation: data?.startLocation,
        endLocation: data?.endLocation,
        stops,
        assignedVehicle: data?.assignedVehicle,
        assignedDriver: data?.assignedDriver,
        timings: {
          departure: data?.departure ? moment(data.departure, "HH:mm").format("hh:mm A") : "",
          arrival: data?.arrival ? moment(data.arrival, "HH:mm").format("hh:mm A") : "",
        },
      };
      const response = await api.updateRoute(item._id, payload);
      if (response?.success) {
        await getRoute();
        notify.success("Route updated successfully!");
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    (async () => {
      try {
        setLoader(true);
        const [v, d] = await Promise.all([api.getVehicle(), api.getDrivers()]);
        if (v?.success) setVehicles(v?.vehicles || []);
        if (d?.success) setDrivers(d?.drivers || []);
      } catch (e) {} finally { setLoader(false); }
    })();
  }, []);

  return (
    <Modal show={true} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}><i className="fa-solid fa-xmark" /></div>
        <div className="h3">Edit Route</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Name</label>
              <input type="text" name="name" className="form-control" value={data?.name} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Start Location</label>
              <input type="text" name="startLocation" className="form-control" value={data?.startLocation} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>End Location</label>
              <input type="text" name="endLocation" className="form-control" value={data?.endLocation} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Stops:</label>
              {stops.map((stop, index) => (
                <div key={index} className="d-flex gap-2 mb-2">
                  <input type="text" placeholder={`Stop ${index + 1}`} value={stop} onChange={(e) => handleStopChange(e.target.value, index)} className="form-control" />
                  {stops.length > 1 && (
                    <button type="button" onClick={() => removeStop(index)} className="bg-red-500 text-white px-2">❌</button>
                  )}
                </div>
              ))}
              <button type="button" onClick={addStop} style={{ background: "#1b2580", color: "#fff", border: "none", borderRadius: 7, padding: "7px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}>
                <i className="fa-solid fa-plus" /> Add Stop
              </button>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Departure Time</label>
              <input type="time" name="departure" className="form-control" value={data?.departure} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Arrival Time</label>
              <input type="time" name="arrival" className="form-control" value={data?.arrival} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Assigned Vehicle</label>
              <select name="assignedVehicle" className="form-control" value={data?.assignedVehicle} onChange={onTextChange}>
                <option value="">Select</option>
                {vehicles.map((item, key) => <option value={item?._id} key={key}>{item?.numberPlate}</option>)}
              </select>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Assigned Driver</label>
              <select name="assignedDriver" className="form-control" value={data?.assignedDriver} onChange={onTextChange}>
                <option value="">Select</option>
                {drivers.map((item, key) => <option value={item?._id} key={key}>{item?.name}</option>)}
              </select>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <button className="themeBtn w-100 text-center" onClick={handleSubmit}>Update</button>
        </div>
      </div>
    </Modal>
  );
};
